import { color, size } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled, { css } from "styled-components";
import Box from "../../Box";
export const textFieldViewContainerStyles = css `
  background-color: ${color.background.input.default};
  display: flex;
  border: solid 1px ${color.border.input.default};
  border-radius: ${size.borderRadius};
  transition: border 0.3s ease;

  &.gradientBorder {
    background:
      linear-gradient(
          ${color.background.input.default},
          ${color.background.input.default}
        )
        padding-box,
      linear-gradient(
          90deg,
          ${color.base.hostingBlue.$600} 0%,
          ${color.base.softContrastViolet.$300} 100%
        )
        border-box;
    border: 1px solid transparent;

    &.hover {
      background:
        linear-gradient(
            ${color.background.input.hovered},
            ${color.background.input.hovered}
          )
          padding-box,
        linear-gradient(
            90deg,
            ${color.base.hostingBlue.$600} 0%,
            ${color.base.softContrastViolet.$300} 100%
          )
          border-box;
      border: 1px solid transparent;
    }

    &:disabled,
    &.disabled {
      background:
        linear-gradient(
            ${color.background.input.disabled},
            ${color.background.input.disabled}
          )
          padding-box,
        linear-gradient(
            90deg,
            ${color.base.hostingBlue.$600} 0%,
            ${color.base.softContrastViolet.$300} 100%
          )
          border-box;
      border: 1px solid transparent;
      color: ${color.font.input.disabled};
    }

    &.focus {
      background:
        linear-gradient(
            ${color.background.input.focused},
            ${color.background.input.focused}
          )
          padding-box,
        linear-gradient(
            90deg,
            ${color.base.hostingBlue.$600} 0%,
            ${color.base.softContrastViolet.$300} 100%
          )
          border-box;
      border: 1px solid transparent;
    }
  }

  &.hover {
    background-color: ${color.background.input.hovered};
    border-color: ${color.border.input.hovered};
  }

  &:disabled,
  &.disabled {
    background-color: ${color.background.input.disabled};
    border-color: ${color.border.input.disabled};
    color: ${color.font.input.disabled};
    /**
         * Just for you Safari!
         */
    opacity: 1;
    -webkit-text-fill-color: ${color.font.input.disabled};
  }

  &.focus {
    background-color: ${color.background.input.focused};
    border-color: ${color.border.input.focused};
  }

  &.hasError:not(.focus) {
    border-color: ${color.border.input.error};
    background-color: ${color.background.input.error};
  }

  &.hidden {
    opacity: 0;
    height: 0;
  }
`;
export const ContentContainer = styled(Box) `
  ${textFieldViewContainerStyles}
`;
//# sourceMappingURL=data:application/json;base64,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